import { Text } from '@cko/primitives';
import styled from 'styled-components';
/**
 * @deprecated - This component is a styled Text with color applied. Replace with Toolkit Text component and your required styles
 */
export const Label = styled(Text) `
  color: var(--base-text-secondary);
`;
